import React from "react";

import { styled } from "../styled";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";

import { theme } from "../theme";

const CustomFormControl = styled(FormControl)({
	/* margin: theme.spacing(1), */
	minWidth: 120,
	width: "100%",
	flex: 1,
});

const CustomTextField = styled(TextField)(({ textfieldvariant }) => ({
	...textfieldvariant,
	paddingLeft: 10,
	borderRadius: 2,
	borderColor: theme.colors.mainGreen.secondary,
	color: "white",
	border: `1px solid ${theme.colors.mainGreen.secondary}`,
	borderRadius: 20,
	backgroundColor: "#FFF",
	textAlign: "center",
}));

const CustomFormLabel = styled(FormLabel)({
	marginBottom: 5,
	paddingBottom: 0,
	color: "black",
	fontSize: 14,
});

const formControlLabelPlacementTop = {
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
};

const formLabelLabelPlacementTop = {
	marginBottom: 0,
	paddingRight: 8,
};

const variants = {
	grey: {
		backgroundColor: "#f9f5fa",
		color: "#FFFFFF",
	},
	white: {
		backgroundColor: "white",
		color: "#FFFFFF",
		textAlign: "center",
		verticalAlign: "center",
	},
	column: {
		marginTop: "4%",
	},
};

export const SpTextArea = ({ label, displayLabel = true, formControlStyle, textfieldVariant = "white", labelPlacementLeft, InputProps, inputPropsStyle, ...rest }) => {
	const controlStyle = {
		...formControlStyle,
		...(labelPlacementLeft && formControlLabelPlacementTop),
	};

	const labelStyle = labelPlacementLeft ? formLabelLabelPlacementTop : {};

	return (
		<CustomFormControl style={controlStyle}>
			{displayLabel ? <CustomFormLabel style={labelStyle}>{label}</CustomFormLabel> : <></>}
			<CustomTextField
				{...rest}
				textfieldvariant={variants[textfieldVariant]}
				variant={"standard"}
				multiline
				rowsMax={3}
				rows={3}
				InputProps={{
					...InputProps,
					disableUnderline: true,
				}}
				inputProps={{
					style: {
						color: theme.colors.mainGreen.secondary,
						...inputPropsStyle,
					},
				}}
			/>
		</CustomFormControl>
	);
};

export default SpTextArea;
